import { IMicrophoneAudioTrack, IRemoteAudioTrack } from "agora-rtc-react";


interface LocalVoiceActivity {
  localMicrophoneTrack: IMicrophoneAudioTrack | null;
  isLocalVoiceDetected: boolean;
  setIsLocalVoiceDetected: (arg: boolean) => void;
}
interface RemoteVoiceActivity {
  remoteAudioTracks: IRemoteAudioTrack[];
  isRemoteVoiceDetected: boolean;
  setIsRemoteVoiceDetected: (arg: boolean) => void;
}

const LOCAL_VOICE_THRESHOLD = 0.1;
const REMOTE_VOICE_THRESHOLD = 0.1;

export const useDetectLocalVoiceActivity = ({
  localMicrophoneTrack,
  setIsLocalVoiceDetected,
}: LocalVoiceActivity) => {
  localMicrophoneTrack?.setAudioFrameCallback(buffer => {
    for (let channel = 0; channel < buffer.numberOfChannels; channel += 1) {
      // Float32Array with PCM data
      const currentChannelData = buffer.getChannelData(channel);
      // console.log("PCM data in channel", channel, currentChannelData);

      // Voice activity detection logic (simple threshold example)
      const threshold = LOCAL_VOICE_THRESHOLD; // Adjust this threshold as needed
      let maxVolume = 0;

      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let i = 0; i < currentChannelData.length; i++) {
        maxVolume = Math.max(maxVolume, Math.abs(currentChannelData[i]));
        // console.log(volume); // This freezes the tab
      }

      // Assuming you want to detect voice if maxVolume exceeds a threshold
      if (maxVolume > threshold) {
        // console.log(maxVolume);
        setIsLocalVoiceDetected(true);
      } else {
        setIsLocalVoiceDetected(false);
      }
    }
  }, 2048);
};

export const useDetectRemoteVoiceActivity = ({
  remoteAudioTracks,
  setIsRemoteVoiceDetected,
}: RemoteVoiceActivity) => {
  //! NOTE: This is ideally supposed to update an array of states (so that each remote user can have their voice detected and UI updated independently) not a single state like what is implemented currently.
  remoteAudioTracks?.map(track =>
    track.setAudioFrameCallback(buffer => {
      for (let channel = 0; channel < buffer.numberOfChannels; channel += 1) {
        // Float32Array with PCM data
        const currentChannelData = buffer.getChannelData(channel);
        // console.log("PCM data in channel", channel, currentChannelData);

        // Voice activity detection logic (simple threshold example)
        const threshold = REMOTE_VOICE_THRESHOLD; // Adjust this threshold as needed
        let maxVolume = 0;

        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < currentChannelData.length; i++) {
          maxVolume = Math.max(maxVolume, Math.abs(currentChannelData[i]));
          // console.log(volume); // This freezes the tab
        }

        // Assuming you want to detect voice if maxVolume exceeds a threshold
        if (maxVolume > threshold) {
          // console.log(maxVolume);
          setIsRemoteVoiceDetected(true);
        } else {
          setIsRemoteVoiceDetected(false);
        }
      }
    }, 2048)
  );
};
